





































































import Vue from "vue";
import Card from "@/components/molecules/DisplayKeyValueGroup/index.vue";
import ResetPasswordForm from "@/components/organisms/ResetPasswordForm/index.vue";

export default Vue.extend({
  components: {
    ResetPasswordForm,
  },
  props: {
    loginUserInfo: {
      type: Object,
    },
    changeEmailRequestIsDone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { attributes } = this.loginUserInfo;
    return {
      userInfo: {
        name: this.loginUserInfo.username || "",
        email: attributes ? attributes.email : "",
      },
      authCode: "",
    };
  },
  methods: {
    handleOnChangePassword(newPassword: any) {
      this.$emit("changePassword", newPassword);
    },
    changeEmail() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const { email } = this.userInfo;
          this.$emit("changeEmail", email);
        }
      });
    },
    verifyEmail() {
      if (this.authCode === "") {
        return;
      }
      this.$emit("verifyEmail", this.authCode);
    },
  },
  watch: {
    loginUserInfo(val, oldVal) {
      const { attributes } = val;
      this.userInfo = {
        name: val.username || "",
        email: attributes ? attributes.email : "",
      };
    },
  },
});
